import React from "react";
import { CheckIcon, GlobeIcon, ShieldCheckIcon, ZapIcon, InfinityIcon, CreditCardIcon } from "lucide-react";
import { offerStack, images } from "../data/content";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
const perks = [{
  icon: CreditCardIcon,
  label: "One-time payment"
}, {
  icon: InfinityIcon,
  label: "Lifetime access"
}, {
  icon: ZapIcon,
  label: "Immediate digital access"
}, {
  icon: CheckIcon,
  label: "No monthly subscription"
}, {
  icon: ShieldCheckIcon,
  label: "7-Day Guarantee"
}];
export function OfferSection() {
  return <section id="offer" className="w-full bg-ink px-5 py-16 sm:py-20" data-id="element-181" data-mp="refyeacvu97j">
      <div className="mx-auto max-w-2xl" data-id="element-182" data-mp="wd9emajk0ebe">
        <div className="text-center" data-id="element-183" data-mp="wc7y3qjrqzma">
          <p className="text-sm font-bold uppercase tracking-wider text-gold" data-id="element-184" data-mp="2t5jcxapw87xd">Special launch offer</p>
          <h2 className="mt-3 font-serif text-[30px] font-black leading-tight text-white sm:text-5xl" data-id="element-185" data-mp="2y3uj9bgzc0au">Here’s everything you’ll receive today</h2>
        </div>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white" data-id="element-186" data-mp="12plbesmtlb9a">
          <img src={images.mainMockup} alt="Everything included in The Sexual Control Protocol" className="w-full bg-cream" data-id="element-187" data-mp="xw0b2txr856x" />
          <div className="p-6 sm:p-8" data-id="element-188" data-mp="sxyviizjeo07">
            <ul className="divide-y divide-ink/10" data-id="element-189" data-mp="ownbcszfmuze">
              {offerStack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-190" data-mp="1lm4gn6ui6f0k">
                  <span className="flex gap-2.5 text-[15px] font-semibold text-ink sm:text-base" data-id="element-191" data-mp="1gnjeh1voxl9h">
                    <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-192" data-mp="1clfzi39tbyjg" />
                    {item.label}
                  </span>
                  <span className="shrink-0 text-sm font-semibold text-ink/50 line-through" data-id="element-193" data-mp="17oxx3a1ygcaa">${item.value}</span>
                </li>)}
            </ul>

            <div className="mt-4 flex items-center justify-between rounded-xl bg-cream px-4 py-3" data-id="element-194" data-mp="3sc16bszbvsne">
              <span className="font-bold text-ink" data-id="element-195" data-mp="3tvasrzw6x6b3">Total value</span>
              <span className="font-bold text-danger line-through" data-id="element-196" data-mp="2o81l8gcr00v">$398</span>
            </div>

            <div className="mt-8 text-center" data-id="element-197" data-mp="3ktuma38hxoc5">
              <p className="text-sm font-bold uppercase tracking-wider text-ink/60" data-id="element-198" data-mp="3kt1nppjoy553">Today you can get everything for:</p>
              <p className="mt-1 font-serif text-[88px] font-black leading-none text-ink sm:text-[112px]" data-id="element-199" data-mp="3owr96652k6lw">
                <span className="align-top text-4xl sm:text-5xl" data-id="element-200" data-mp="3fu889rkug42a">$</span>27
              </p>
              <p className="mt-2 text-sm font-semibold text-success" data-id="element-201" data-mp="3fw1cl07zic74">You save $371 (93% off)</p>
            </div>

            <ul className="mt-6 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-202" data-mp="3645gfupgkw5j">
              {perks.map(p => <li key={p.label} className="flex items-center gap-2 text-[15px] text-ink/80" data-id="element-203" data-mp="2s4451lbki6bt">
                  <p.icon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-204" data-mp="2x48mbdkav533" />
                  {p.label}
                </li>)}
            </ul>

            <div className="mt-6 flex items-start gap-3 rounded-xl border border-teal/30 bg-teal-soft p-4" data-id="element-205" data-mp="2dk1g7rzi6orv">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-206" data-mp="28l6tieyf0g2h" />
              <p className="text-sm leading-snug text-ink/80" data-id="element-207" data-mp="2mgacwyw3j9ab">
                <strong className="text-ink" data-id="element-208" data-mp="2ig8npp7js8bx">Automatic currency conversion:</strong> the price is shown in USD and converts automatically to your local currency at checkout.
              </p>
            </div>

            <div className="mt-6 flex flex-col items-center gap-6" data-id="element-209" data-mp="2rh6qk46929sx">
              <CtaButton label="Get it now for $27" sub="Instant access · One-time payment · Lifetime access · 7-Day Guarantee" data-id="element-210" data-mp="366vx6ex4360l" />
              <Countdown note="Launch price: $27. The introductory price may increase after the launch period." data-id="element-211" data-mp="3181dzbv8fffy" />
              <ScarcityBar data-id="element-212" data-mp="3f57uezshh220" />
            </div>
          </div>
        </div>

        <p className="mt-8 text-center text-[15px] leading-relaxed text-white/70" data-id="element-213" data-mp="3a9ip0fts8qxs">
          For less than the cost of a typical dinner, you get a complete 28-day system you can return to whenever you want to rebuild your practice.
        </p>
      </div>
    </section>;
}